<div class="flex flex-col justify-center items-center box-border">
  <ui-paragraph
    type="p14"
    mobile-type="p14"
    font-weight="regular"
    text-color="neutrals-700"
    *ngIf="statusName"
  >
    {{ statusName }}
  </ui-paragraph>
  <ui-paragraph
    type="p24"
    mobile-type="p24"
    font-weight="semibold"
    text-color="neutrals-900"
    *ngIf="amount"
  >
    {{
      $any(amount | currency: ' ' : 'symbol' : '1.0-1' : 'en')
        .toString()
        .trim()
    }}
  </ui-paragraph>
  <unicon-percent-indicator [positive]="positive" [percent]="percent" />
</div>
